'use strict';

angular.module('app').directive('timerDirective', function() {
    var link = function(scope, element) {
        // timer = setInterval(function() {
        //   var now = new Date().getTime(),
        //       distance = countDownDate - now,
        //       days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        //       hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        //       minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        //       seconds = Math.floor((distance % (1000 * 60)) / 1000);
        //
        //   angular.element(element).html(days + "d " + hours + "h " + minutes + "m " + seconds + "s ");
        //
        //   if (distance < 0) {
        //     clearInterval(timer);
        //     angular.element(element).html("Expired");
        //   }
        // }, 1000);

        var date = new Date(scope.endDate),
            today = new Date(),
            timeLeft = (date.getTime()/1000) - (today.getTime()/1000),
            clock;

        clock = $(element).FlipClock(timeLeft, {
            clockFace: 'DailyCounter',
            autoStart: false,
            callbacks: {
                stop: function() {
                    $('.message').html('The clock has stopped!');
                }
            }
        });

        clock.setCountdown(true);
        clock.start();
    };
    return {
        restrict: 'A',
        link: link,
        scope: {
            endDate: '='
        }
    };
});